// Regex kiểm tra password: yêu cầu ít nhất 6 ký tự, không yêu cầu ký tự đặc biệt hay hoa/thường
export const REGEX_PASSWORD = /^.{6,}$/
export const REGEX_ONLY_NUMBER = /^\d+$/
export const REGEX_PHONE = /^(84|0[3-9]|0[1-2][0-9]|0[5-8][0-9]|09)[0-9]{8}$/
export const REGEX_EMAIL = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/
